module.exports = __webpack_public_path__ + "static/media/icon-phone.70ac91c8.svg";